import { useTranslation } from 'react-i18next';
import { ROUTES_NS } from './i18n';
import { PageTitle } from '../components/Page/PageTitle';
import { Box } from '@mui/material';
import BunkeringLogs from '../components/BunkeringLogs/BunkeringLogs';

export const BunkeringLogsRoute = () => {
  const { t } = useTranslation(ROUTES_NS);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <PageTitle>{t('bunkeringLogs')}</PageTitle>
      </Box>
      <BunkeringLogs />
    </>
  );
};
